/* Address Create, Vue Component */
<template>
  <v-card v-if="entity && !loading" id="address-create" class="entity-create">
      <v-card-title>Create Address</v-card-title>

      <v-card-text class="d-flex align-center flex-wrap pb-0">
        <v-alert
          v-if="serverErrorMessage"
          type="error"
        >
          {{ serverErrorMessage }}
        </v-alert>
      </v-card-text>

      <v-card-text class="d-flex align-center flex-wrap pb-0">
      <v-row class="align-center pb-5">
        <v-col>
        <v-btn
          color="primary"
          class="me-3"
          @click="Save"
        >
          <v-icon
            size="18"
            class="me-1"
          >
            {{ icons.mdiContentSaveOutline  }}
          </v-icon>
          <span>Save</span>
        </v-btn>
        </v-col>
        <v-col class="text-right">
        <v-btn
          color="secondary"
          class="me-3"
          @click="Back"
        >
          <v-icon
            size="18"
            class="me-1"
          >
            {{ icons.mdiChevronLeft }}
          </v-icon>
          <span>Back</span>
        </v-btn>
        </v-col>
      </v-row>
      </v-card-text>

      <v-form ref="form">
      <v-simple-table dense>
        <thead>
          <tr>
            <th>Field</th>
            <th>Value</th>
          </tr>
        </thead>
        <tbody>

      <tr>
        <td>Full Name</td>
        <td><v-text-field
      label="Full Name"
      solo-inverted
      flat
      :error-messages="serverErrors.filter(x => x.field === 'FullName').map(x => x.error)"
      v-model="entity.FullName"
      :rules="[validators.required]"
    ></v-text-field>
</td>
      </tr>

      <tr>
        <td>Salutation</td>
        <td><v-text-field
      label="Salutation"
      solo-inverted
      flat
      :error-messages="serverErrors.filter(x => x.field === 'Salutation').map(x => x.error)"
      v-model="entity.Salutation"
      :rules="[]"
    ></v-text-field>
</td>
      </tr>

      <tr>
        <td>Line 1</td>
        <td><v-text-field
      label="Line 1"
      solo-inverted
      flat
      :error-messages="serverErrors.filter(x => x.field === 'Address1').map(x => x.error)"
      v-model="entity.Address1"
      :rules="[]"
    ></v-text-field>
</td>
      </tr>

      <tr>
        <td>Line 2</td>
        <td><v-text-field
      label="Line 2"
      solo-inverted
      flat
      :error-messages="serverErrors.filter(x => x.field === 'Address2').map(x => x.error)"
      v-model="entity.Address2"
      :rules="[]"
    ></v-text-field>
</td>
      </tr>

      <tr>
        <td>Line 3</td>
        <td><v-text-field
      label="Line 3"
      solo-inverted
      flat
      :error-messages="serverErrors.filter(x => x.field === 'Address3').map(x => x.error)"
      v-model="entity.Address3"
      :rules="[]"
    ></v-text-field>
</td>
      </tr>

      <tr>
        <td>Line 4</td>
        <td><v-text-field
      label="Line 4"
      solo-inverted
      flat
      :error-messages="serverErrors.filter(x => x.field === 'Address4').map(x => x.error)"
      v-model="entity.Address4"
      :rules="[]"
    ></v-text-field>
</td>
      </tr>

      <tr>
        <td>Postcode</td>
        <td><v-text-field
      label="Postcode"
      solo-inverted
      flat
      :error-messages="serverErrors.filter(x => x.field === 'Postcode').map(x => x.error)"
      v-model="entity.Postcode"
      :rules="[]"
    ></v-text-field>
</td>
      </tr>

      <tr>
        <td>Telephone</td>
        <td><v-text-field
      label="Telephone"
      solo-inverted
      flat
      :error-messages="serverErrors.filter(x => x.field === 'Telephone').map(x => x.error)"
      v-model="entity.Telephone"
      :rules="[]"
    ></v-text-field>
</td>
      </tr>

      <tr>
        <td>IsDeleted</td>
        <td><v-checkbox v-model="entity.IsDeleted" :color="(entity.IsDeleted ? 'success' : 'secondary')"></v-checkbox></td>
      </tr>

      <tr>
        <td>Delivery Point Id</td>
        <td><v-text-field
      label="Delivery Point Id"
      solo-inverted
      flat
      :error-messages="serverErrors.filter(x => x.field === 'DeliveryPointId').map(x => x.error)"
      v-model="entity.DeliveryPointId"
      :rules="[]"
    ></v-text-field>
</td>
      </tr>

      <tr>
        <td>Member</td>
        <td><MemberLookup v-model="entity.MemberId" :rules="[]" :error-messages="serverErrors.filter(x => x.field === 'MemberId').map(x => x.error)" /></td>
      </tr>

      <tr>
        <td>Country</td>
        <td><CountryLookup v-model="entity.CountryId" :rules="[]" :error-messages="serverErrors.filter(x => x.field === 'CountryId').map(x => x.error)" /></td>
      </tr>


        </tbody>
      </v-simple-table>
      </v-form>

  </v-card>
</template>

<script>
import store from '@/store'
import { useRouter } from '@core/utils'
import * as Display from '@/datahelpers/displayTypes'
import * as FrameworkValidators from '@core/utils/validation'
import * as Validators from '@/datahelpers/validation'

import MemberLookup from '@/views/member/MemberLookup'
import CountryLookup from '@/views/country/CountryLookup'

import {
  mdiContentSaveOutline,
  mdiChevronLeft
} from '@mdi/js'
import { ref, watch, computed, expose } from '@vue/composition-api'

export default {
  components: {

    MemberLookup,
		CountryLookup
  },
  setup() {

    const { route, router  } = useRouter();

    const entity = ref({

    });
    const loading = ref(false);
    const form = ref(null);
    const serverErrors = ref([]);
    const serverErrorMessage = ref(null);

    const Save = function(e) {

      serverErrorMessage.value = null;
      serverErrors.value = [];

      const valid = form.value.validate();

      if (!valid) {
        return;
      }

      loading.value = true;

      store
        .dispatch('app/createAddress', {
          entity: entity.value
        })
        .then(response => {
          loading.value = false;
          router.push({ name: 'address-view', params: { id: response.data.Id } });
        })
        .catch((error) => {
          loading.value = false;
          if (error.error) {
            if (error.message) serverErrorMessage.value = error.message;
            if (error.errors) serverErrors.value = error.errors
          } else {
            console.log(error);
          }
        });
    };

    const Back = () => {
      router.go(-1);
    };

    const validators = {
      ...FrameworkValidators,
      ...Validators
    };

    return {
      Back,
      form,
      Save,
      loading,
      entity,
      Display,
      icons: {
        mdiContentSaveOutline ,
        mdiChevronLeft
      },
      validators,
      serverErrorMessage,
      serverErrors
    };
  }
}
</script>

<style lang="scss" scoped>
.entity-create::v-deep .v-data-table > .v-data-table__wrapper > table > tbody > tr > td:last-child {
  padding-right: 0;
}
.entity-create::v-deep .v-data-table th:last-child {
  width: 66%;
}
.entity-create::v-deep  .theme--light.v-data-table > .v-data-table__wrapper > table > tbody > tr:hover:not(.v-data-table__expanded__content):not(.v-data-table__empty-wrapper) {
  background: transparent;
}
.entity-create::v-deep .v-input:not(.error--text) .v-messages {
  min-height: unset;
}
.entity-create::v-deep .v-input .v-messages.error--text {
  margin-bottom: 8px;
}
.entity-create::v-deep .v-input:not(.error--text) .v-text-field__details {
  min-height: unset;
  margin-bottom: 0;
}
.entity-create::v-deep .v-input:not(.error--text) .v-input__slot {
  margin: 0;
  border-radius: 0;
}
.entity-create::v-deep .v-input--selection-controls {
  margin: 10px;
}
</style>

